var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("input", {
      attrs: { type: "hidden", name: "invoice_items" },
      domProps: { value: JSON.stringify(_vm.services) },
    }),
    _vm._v(" "),
    _vm.loading
      ? _c("div", [_vm._m(0)])
      : _c(
          "div",
          [
            _vm.items.length > 0
              ? _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  !_vm.readOnly
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-block purple",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.addService("prepend")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v(" Ajouter un service"),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function (item, index) {
              return _c("div", { key: index }, [
                item.type == "service"
                  ? _c(
                      "div",
                      {
                        staticClass: "service-item",
                        staticStyle: {
                          position: "relative",
                          "margin-bottom": "10px",
                        },
                      },
                      [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c(
                            "div",
                            { staticStyle: { "flex-grow": "1" } },
                            [
                              _c(
                                "div",
                                { staticStyle: { padding: "0 5px 5px 0" } },
                                [_vm._v("Service")]
                              ),
                              _vm._v(" "),
                              _c("select-two-items", {
                                ref:
                                  "select2-item-service-" + item.service_index,
                                refInFor: true,
                                staticStyle: { width: "100%" },
                                attrs: {
                                  id:
                                    "select2-item-service-" +
                                    item.service_index,
                                  "dropdown-parent": "#form_invoice",
                                  endpoint: _vm.itemEndpoint,
                                  type: item.type,
                                  "initial-value": item.invoice_detail_item.id
                                    ? item.invoice_detail_item.id.toString()
                                    : "",
                                  "initial-display":
                                    item.invoice_detail_item.text,
                                  "add-form-base-end-point":
                                    _vm.baseEndpoint + "service/add",
                                  "add-form-title": "Ajout d'un service",
                                  "add-form-selector": "#form_service",
                                  "add-text-input-selector": "#service_name",
                                  "edit-form-base-end-point":
                                    _vm.baseEndpoint + "service/edit",
                                  "edit-form-title": "Modifier un service",
                                  "edit-form-selector": "#form_service",
                                  "edit-text-input-selector": "#service_name",
                                  "allow-add": _vm.allowAddServices,
                                  "allow-edit": _vm.allowEditServices,
                                },
                                on: {
                                  selected: function ($event) {
                                    return _vm.onSelect(
                                      item.service_index,
                                      item.part_index,
                                      $event
                                    )
                                  },
                                  clear: function ($event) {
                                    return _vm.onClear(
                                      item.service_index,
                                      item.part_index
                                    )
                                  },
                                },
                                model: {
                                  value: item.invoice_detail_item,
                                  callback: function ($$v) {
                                    _vm.$set(item, "invoice_detail_item", $$v)
                                  },
                                  expression: "item.invoice_detail_item",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "5px" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { "flex-grow": "1" } },
                                        [
                                          _c("div", [_vm._v("Description:")]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      item.invoice_detail_description,
                                                    expression:
                                                      "item.invoice_detail_description",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "100px",
                                                  "min-height": "35px",
                                                  resize: "vertical",
                                                },
                                                domProps: {
                                                  value:
                                                    item.invoice_detail_description,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      item,
                                                      "invoice_detail_description",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "5px",
                                            width: "170px",
                                          },
                                        },
                                        [
                                          _c("div", [_vm._v("Quantité:")]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      item.invoice_detail_qty,
                                                    expression:
                                                      "item.invoice_detail_qty",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control invoice_detail_qty",
                                                staticStyle: { width: "100%" },
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    item.invoice_detail_qty,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      item,
                                                      "invoice_detail_qty",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.isSoumission
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-left invoice_detail_parts_status_div",
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "invoice_detail_parts_status",
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        checked:
                                                          item.invoice_detail_parts_status ==
                                                          1,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.checkboxOrderStatusChange(
                                                            item,
                                                            1,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.checkboxOrderStatusChange(
                                                              item,
                                                              1,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Pièces à commander"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-left invoice_detail_parts_status_div",
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "invoice_detail_parts_status",
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        checked:
                                                          item.invoice_detail_parts_status ==
                                                          2,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.checkboxOrderStatusChange(
                                                            item,
                                                            2,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.checkboxOrderStatusChange(
                                                              item,
                                                              2,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Pièces commandées"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-left invoice_detail_parts_status_div",
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "invoice_detail_parts_status",
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        checked:
                                                          item.invoice_detail_parts_status ==
                                                          3,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.checkboxOrderStatusChange(
                                                            item,
                                                            3,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.checkboxOrderStatusChange(
                                                              item,
                                                              3,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Pièces reçues")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticStyle: { "margin-left": "5px" } }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-circle btn-icon-only btn-default tooltips",
                                attrs: {
                                  "data-container": "body",
                                  "data-placement": "top",
                                  "data-original-title": "Supprimer",
                                  href: "javascript:;",
                                  title: "Supprimer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(
                                      item.service_index,
                                      item.part_index
                                    )
                                  },
                                },
                              },
                              [_c("i", { staticClass: "icon-trash" })]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(item.parts, function (part, index2) {
                          return _c(
                            "div",
                            {
                              key: index2,
                              staticClass: "part-item",
                              staticStyle: { "margin-right": "40px" },
                            },
                            [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { "flex-grow": "1" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { padding: "0 5px 5px 0" },
                                      },
                                      [_vm._v("Pièce")]
                                    ),
                                    _vm._v(" "),
                                    _c("select-two-items", {
                                      ref:
                                        "select2-item-part-" +
                                        part.service_index +
                                        "-" +
                                        part.part_index,
                                      refInFor: true,
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        id:
                                          "select2-item-part-" +
                                          index +
                                          "-" +
                                          index2,
                                        endpoint: _vm.itemEndpoint,
                                        type: part.type,
                                        "initial-value":
                                          part.invoice_detail_item.id,
                                        "initial-display":
                                          part.invoice_detail_item.text,
                                        "add-form-base-end-point":
                                          _vm.baseEndpoint + "part/add",
                                        "add-form-title": "Ajout d'une pièce",
                                        "add-form-selector": "#form_part",
                                        "add-text-input-selector": "#part_name",
                                        "edit-form-base-end-point":
                                          _vm.baseEndpoint + "part/edit",
                                        "edit-form-title": "Modifier une pièce",
                                        "edit-form-selector": "#form_part",
                                        "edit-text-input-selector":
                                          "#part_name",
                                        "allow-add": _vm.allowAddParts,
                                        "allow-edit": _vm.allowEditParts,
                                        "allow-quick-add": _vm.allowAddParts,
                                      },
                                      on: {
                                        selected: function ($event) {
                                          return _vm.onSelect(
                                            part.service_index,
                                            part.part_index,
                                            $event
                                          )
                                        },
                                        clear: function ($event) {
                                          return _vm.onClear(
                                            part.service_index,
                                            part.part_index
                                          )
                                        },
                                      },
                                      model: {
                                        value: part.invoice_detail_item,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            part,
                                            "invoice_detail_item",
                                            $$v
                                          )
                                        },
                                        expression: "part.invoice_detail_item",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { "margin-top": "5px" } },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { display: "flex" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "flex-grow": "1",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v("Description:"),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "5px",
                                                    },
                                                  },
                                                  [
                                                    _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            part.invoice_detail_description,
                                                          expression:
                                                            "part.invoice_detail_description",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "50px",
                                                        "min-height": "35px",
                                                        resize: "vertical",
                                                      },
                                                      domProps: {
                                                        value:
                                                          part.invoice_detail_description,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            part,
                                                            "invoice_detail_description",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-left": "5px",
                                                  width: "170px",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v("Quantité:"),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "5px",
                                                    },
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            part.invoice_detail_qty,
                                                          expression:
                                                            "part.invoice_detail_qty",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control invoice_detail_qty",
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: { type: "number" },
                                                      domProps: {
                                                        value:
                                                          part.invoice_detail_qty,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            part,
                                                            "invoice_detail_qty",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-left": "5px" } },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-circle btn-icon-only btn-default tooltips",
                                        attrs: {
                                          "data-container": "body",
                                          "data-placement": "top",
                                          "data-original-title": "Supprimer",
                                          href: "javascript:;",
                                          title: "Supprimer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(
                                              part.service_index,
                                              part.part_index
                                            )
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "icon-trash" })]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "5px",
                              "margin-right": "40px",
                            },
                          },
                          [
                            !_vm.readOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-block btn-sm secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addPart(item.service_index)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-plus" }),
                                    _vm._v(" Ajouter une pièce"),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-top": "5px" } }, [
              !_vm.readOnly
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-block purple",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.addService("append")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(" Ajouter un service"),
                    ]
                  )
                : _vm._e(),
            ]),
          ],
          2
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "text-center" }, [
      _c("span", { staticStyle: { "font-size": "22px" } }, [
        _c("i", { staticClass: "fa fa-refresh fa-spin" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }